export default __webpack_public_path__ + "82ccd0564c8c34ca11c79fdd4144e493.svg";